<template>
  <header class="header" :style="$route.name !== 'CompanyIntro'  && $route.name !== 'Download' ? { 'box-shadow': '0 2px 0 #FF2424' } : {'box-shadow': '0 2px 0 #D8D8D8 '}">
    <div class="topHeader">
      <nav class="nav">
        <!--去登录-->
        <span v-if="!isLoggedIn" style="cursor: pointer" @click="ToLogin()">User Login</span>
        <span v-else style="cursor: pointer" @click="ToLogout()">Welcome! &nbsp {{ this.nickname}}</span>
        <span style="margin-left: 30px">|</span>
        <!--公司介绍-->
        <router-link v-if="$route.path !== '/CompanyIntro'" to="/CompanyIntro">Company Profile</router-link>
        <span v-if="$route.path == '/ShopDetail' || $route.path == '/Download'" style="margin-left: 30px">|</span>
        <router-link v-if="$route.path !== '/'" to="/">Home</router-link>
<!--        <router-link to="/products">中英文切换▼</router-link>-->
      </nav>
    </div>
    <div class="container">
      <div class="logoInputButDiv">
        <div class="xiazaiDiv1" v-if=" $route.name == 'Download'">
          <div class="xiazaiLeft">
            <img src="@/assets/xiazai-icon.png" alt="">
          </div>
          <div class="logoRight">
            <div>
              <span class="DownloadsSpan">Downloads</span>
            </div>

          </div>
        </div>
        <div class="logoDiv1" v-else>
<!--          <div class="logoLeft">-->
<!--            <router-link to="/">-->
<!--              <img src="@/assets/cirgouLogo.png" alt="公司Logo">-->
<!--            </router-link>-->
<!--          </div>-->
<!--          <div class="logoRight">-->
<!--            <div>-->
<!--              <span class="cirgouSpan">Cirgou</span>-->
<!--            </div>-->
<!--            <div>-->
<!--&lt;!&ndash;              <span class="fuNengSpan">赋能餐饮无限可能</span>&ndash;&gt;-->
<!--              <span class="fuNengSpan">Unleashing Infinite Possibilities</span>-->
<!--            </div>-->

<!--          </div>-->

          <router-link to="/">
            <img style="width: 200px;height: 66px" src="@/assets/cirgouLogoNew.png" alt="公司Logo">
          </router-link>

        </div>

        <!-- 当公司介绍页面不显示搜索框-->
        <div class="search-box" v-if="$route.name !== 'CompanyIntro' && $route.name !== 'Download'">
          <!--placeholder="搜索你喜欢的餐馆"-->
          <el-input
            v-model="searchShopText"
            placeholder="Restaurants"
            clearable
            class="search-input"
            @keyup.enter="funSearchShop"
          >
          </el-input>
<!--          <el-button @click="funSearchShop">搜索</el-button>-->
          <el-button @click="funSearchShop">Search</el-button>
        </div>
        <div style="width: 150px">
          <!--布局占位-->
          <!-- <div class="fanhuiDiv1" v-if=" $route.name == 'Download'" @click="backFun">
            <div class="fanhuiLeft">
              <img src="@/assets/fanhui.png" alt="">
            </div>
            <div>
              <span class="DownloadsSpan">Back</span>
            </div>
          </div> -->
        </div>



        <!--      <div class="mobile-menu" @click="toggleMenu">-->
        <!--        <i class="icon-menu"></i>-->
        <!--      </div>-->
      </div>
      <!-- 当公司介绍页面不显示搜索框-->
      <div class="allTypeDiv" v-if="$route.name !== 'CompanyIntro'  && $route.name !== 'Download'" >
<!--        <span>全部美食分类</span>-->
        <span>Restaurants</span>
<!--        <i class="el-icon-arrow-down"></i>-->
      </div>
      <div class="xiazaiTypeDiv" v-if="$route.name == 'Download'" >
      </div>

    </div>
  </header>
</template>

<script>
import {Header} from "element-ui";
import Footer from "./Footer";

export default {
  name: 'Header',
  data() {
    return {
      searchShopText: '',//搜索内容
      isLoggedIn: false, // 根据实际登录状态设置
    }
  },
  created () {
    this.checkLoginStatus()
  },
  methods: {
    ToLogin(){
      this.$router.replace({ path: '/LoginRes' })
      window.location.reload()
    },
    ToLogout(){
      this.$confirm('This operation will log out. Do you want to continue?', 'hint', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Exit successfully!'
        });
        localStorage.removeItem("userInfo")
        this.ToLogin()

      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Canceled'
        });
      });

    },
    toggleMenu() {
      // 移动端菜单切换逻辑
    },
    // 搜索按钮方法
    funSearchShop() {
      console.log('搜索内容:', this.searchShopText)
      if (this.$route.name !== 'ShopHome') {
        this.$router.push({
          path: '/',
          query: {
            searchText: this.searchShopText
          }
        })
      } else {
        this.$parent.handleSearch(this.searchShopText)//把搜索内容传递给父组件ShopHome.vue

      }

    },
    // 检查登录状态的方法
    checkLoginStatus() {
      // 示例：检查本地存储的token
      this.isLoggedIn = !!localStorage.getItem("userInfo")
      if (this.isLoggedIn) {
        this.nickname = JSON.parse(localStorage.getItem("userInfo"))[0].c_name
      }
    },
    // 此方法给父组件调用
    childMethod(searchShopText) {
      console.log("子组件的方法被调用了！",searchShopText);
      this.searchShopText = searchShopText;
    },
    backFun(){
      this.$router.go(-1)
    }


  }
}
</script>

<style scoped>
.header {
  background: #fff;
  /*box-shadow: 0 2px 0 #FF2424 ;*/
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.container {
  align-items: center;
  /*height: 148px;*/
  max-width: 1458px;
}
.logoInputButDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}
.allTypeDiv {
  background-color: #FF2424 ;
  height: 39px;
  width: 239px;
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  color: #FFFFFF;
  align-items: center;      /* 垂直居中 */
  padding: 0 15px;          /* 左右内边距，让内容向中间靠拢 */
}
.xiazaiTypeDiv {
  background-color: #FF2424 ;
  height: 5px;
  width: 250px;
}

.allTypeDiv i {
  font-size: 14px;          /* 调整图标大小（可选） */
}

.logoLeft img {
  height: 66px;
  margin-top: 12px;
}

.xiazaiLeft img {
  height: 32px;
}

.fanhuiLeft img {
  height: 27px;
}



.nav {
  margin-right: 100px;
}

.nav a {
  margin-left: 30px;
  color: #333;
  text-decoration: none;
  font-weight: 500;
}

.nav a.router-link-exact-active {
  color: #42b983;
}

.mobile-menu {
  display: none;
  font-size: 24px;
  cursor: pointer;
}

@media (max-width: 768px) {  /* 当屏幕宽度 ≤ 768px 时生效 */
  .nav {
    display: none;          /* 隐藏桌面导航栏 */
  }
  .mobile-menu {
    display: block;         /* 显示移动端菜单按钮（通常是☰汉堡图标） */
  }
}
/*最顶部导航栏样式*/
.topHeader {
  background: #F6F6F6;
  width: 100%;
  top: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 47px;
}

.logoRight {
  margin-left: 14px;
}

/*搜索框+搜索按钮样式*/
.search-box {
  display: flex;
  width: 754px;
}

/* 搜索按钮样式调整 */
.search-box .el-button {
  border-radius: 0 4px 4px 0;
  border-left: none;
  width: 134px;
  height: 39px;
  background-color: #FF2424;
  color: #FFF;
  border-color: #FF2424;
}

/* 输入框样式调整 */
.search-box /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px 0 0 4px;
  border: 1px solid #FF2424;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 39px;
  width: 635px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);

}

.logoDiv1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xiazaiDiv1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 40px;
  padding-left: 40px;
}
.fanhuiDiv1 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 40px;
  padding-left: 65px;
  cursor: pointer; /*鼠标手效果*/
}
.DownloadsSpan {
  width: 128px;
  height: 21px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 23px;
  color: #5D5D5D;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.cirgouSpan {
  width: 131px;
  height: 52px;
  font-family: Arial, Arial;
  font-weight: 700;
  font-size: 34px;
  color: #000000;
  line-height: 52px;
  letter-spacing: 4px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}
.fuNengSpan {
  width: 128px;
  height: 24px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue